
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ScrollToTopButton from '../../components/feature/ScrollToTopButton';
import HeroSlider from './components/HeroSlider';
import AboutSection from './components/AboutSection';
import ProductsSection from './components/ProductsSection';
import InquirySection from './components/InquirySection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  useEffect(() => {
    const shouldScroll = sessionStorage.getItem('scrollToInquiry');
    if (shouldScroll === 'true') {
      sessionStorage.removeItem('scrollToInquiry');
      setTimeout(() => {
        const el = document.getElementById('inquiry-section');
        if (el) {
          el.scrollIntoView({ behavior: 'auto' });
        }
      }, 300);
    }
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSlider />
        <AboutSection />
        <ProductsSection />
        <InquirySection />
        <ContactSection />
      </main>
      <Footer />
      <ScrollToTopButton />
    </div>
  );
}
